import { TextButton } from '@shape-ds/components';
import React from 'react';
import './style.scss';
import { useTranslation } from 'react-i18next';
import { useCopyText } from './useCopyText';

interface CopyButtonProps {
  text?: string;
  showCopyText?: boolean;
}

const CopyButton: React.FC<CopyButtonProps> = ({ text, showCopyText = true }) => {
  const { t } = useTranslation();
  const { isCopied, copy, Icon } = useCopyText(text);

  if (!text) return null;

  return (
    <TextButton
      endIcon={<Icon className="copy-button-icon" />}
      onClick={copy}
      className={`copy-button ${isCopied ? 'copy-button-done' : ''}`}
    >
      {isCopied ? (
        <p className="copied-id">{showCopyText ? t(`messages:copied_id_success.message`) : ''}</p>
      ) : (
        showCopyText && (
          <>
            <span className="copy-button-label">ID:</span>
            <span className="copy-button-value"> {text.slice(0, 8)}...</span>
          </>
        )
      )}
    </TextButton>
  );
};

export default CopyButton;
